import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IGetProfilesUseCase {
    execute(apiKey: string, token: string, identityToken: string, kidsMode?: boolean): Promise<any>;
}

export class GetProfilesUseCase implements IGetProfilesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, token: string, identityToken: string, kidsMode?: boolean): Promise<any> {
        const result = await this.profileRepository.getProfiles(apiKey, token, identityToken, kidsMode === true);
        return {
            parentalLockOn: result.data.parentalLockOn || false,
            profiles: result.data.profiles,
            version: result.data.prev,
            profilesLimit: result.data.profilesLimit || 5,
        };
    }
}
